<template>
	<div 
		class="modal fade" 
		:class="name" 
		:id="name" 
		tabindex="-1" 
		role="dialog" 
		:aria-labelledby="name+'label'" 
		aria-hidden="true">
	  	<div class="modal-dialog" :class="tamanho">
	    	<div class="modal-content">
	     		<div class="modal-header">
			        <h5 class="modal-title" :id="name+'label'">{{ titulo }}</h5>
				    <button 
				    	type="button" 
				    	class="close" 
				    	data-dismiss="modal" 
				    	aria-label="Fechar" 
				    	:id="name">
				    	<span aria-hidden="true">&times;</span>
				    </button>
			    </div>
			    <div class="modal-body" v-if="!notBody">
			        <slot></slot>
			    </div>
			    <div class="modal-footer">
				    <slot name="footer"></slot>
			    </div>
	    	</div>
	  	</div> 
	</div>
</template>

<script>
	export default {
		props: {
	        titulo: {
	            type: String,
	        },
	        name: {
	            type: String,
	        }, 
	        tamanho: {
	            type: String,
	        },
	        notBody: {
	            type: Boolean,
	            default: false
	        }
	    }
	}
</script>